import { Component, OnInit, ViewChild } from "@angular/core";
import { EmailEditorComponent } from "angular-email-editor";
import { saveAs } from "file-saver";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { MyFocusLoyaltyEmailTemplateItem } from "src/app/shared/models/MyFocusLoyaltyEmailTemplate.item";
import * as uuid from "uuid";

@Component({
	selector: "app-loyalty-email-template-setup",
	templateUrl: "./loyalty-email-template-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class LoyaltyEmailTemplateSetupComponent implements OnInit {
	@ViewChild("editor") emailEditor: EmailEditorComponent;

	editorIsLoaded: boolean = false;
	emailTemplateList: MyFocusLoyaltyEmailTemplateItem[];

	emailTemplateSelected: MyFocusLoyaltyEmailTemplateItem;

	constructor(public app: AppService, private focuslink: FocuslinkService) {}

	ngOnInit(): void {
		this.app.loading(true);
		this.init();
	}

	async init() {
		this.emailTemplateListGet(0);
		this.app.loading(false);
	}

	clearDesign() {
		this.emailEditor.editor.loadBlank();
		this.emailTemplateSelected = undefined;
	}

	editorLoaded(event) {
		this.editorIsLoaded = true;
	}

	loadSelectedTemplate(template: MyFocusLoyaltyEmailTemplateItem) {
		this.emailTemplateSelected = template;
		this.emailEditor.loadDesign(JSON.parse(this.emailTemplateSelected.templateJson));
	}

	saveDesign() {
		return new Promise<void>((resolve, reject) => {
			this.emailEditor.saveDesign((data) => {
				this.emailTemplateSelected.templateJson = JSON.stringify(data);
				resolve();
			});
		});
	}

	saveHtml() {
		return new Promise<void>((resolve, reject) => {
			this.emailEditor.editor.exportHtml((data) => {
				this.emailTemplateSelected.templateHtml = data.html;
				resolve();
			});
		});
	}

	async emailTemplateListGet(venueKey: number) {
		const resp = await this.focuslink.loyaltyEmailTemplateGetAll(venueKey);
		this.emailTemplateList = resp.map((i) => new MyFocusLoyaltyEmailTemplateItem(i));
	}

	emailTemplateNew() {
		this.emailTemplateSelected = new MyFocusLoyaltyEmailTemplateItem({});
	}

	exportHtml() {
		this.emailEditor.editor.exportHtml((data) => {
			var blob = new Blob([data.html], { type: "text/html;charset=utf-8" });
			saveAs(blob, `${this.emailTemplateSelected.name}.html`);
		});
	}

	async save() {
		await this.saveDesign();
		await this.saveHtml();

		this.emailTemplateSelected.sk = this.emailTemplateSelected.sk ? this.emailTemplateSelected.sk : uuid.v4();
		this.emailTemplateSelected.pk = this.emailTemplateSelected.pk ? this.emailTemplateSelected.pk : `LOYEMAILTEMPLATE_0`;
		console.log(this.emailTemplateSelected);
		this.focuslink.loyaltyEmailTemplateSave(0, this.emailTemplateSelected);
		if (!this.emailTemplateList) {
			this.emailTemplateList = [];
		}
		let existing = this.emailTemplateList.find((i) => i.sk === this.emailTemplateSelected.sk);
		if (existing) {
			existing = this.emailTemplateSelected;
		} else {
			this.emailTemplateList.push(this.emailTemplateSelected);
		}
	}
}
